// Local storage for a Pro license key (the no-login payment path).
//
// When a customer pays with BCH without a Nostr account, the server mints a
// license key and returns it. We persist it here so Pro stays unlocked on this
// device. The key is a bearer token — anyone holding it has Pro — so a user can
// also copy it to another device to restore access there.

const LICENSE_STORAGE_KEY = 'bchradar:pro-license';

/** Shape of a valid minted license key. Mirrors the server's format. */
const LICENSE_RE = /^BCHR-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/;

export function isValidLicense(key: string): boolean {
  return LICENSE_RE.test(key.trim().toUpperCase());
}

/** Read the stored license key, or null if none / invalid. */
export function getStoredLicense(): string | null {
  try {
    const raw = localStorage.getItem(LICENSE_STORAGE_KEY);
    if (!raw) return null;
    const key = raw.trim().toUpperCase();
    return isValidLicense(key) ? key : null;
  } catch {
    return null;
  }
}

/** Persist a license key locally. Notifies listeners in this tab. */
export function setStoredLicense(key: string): void {
  try {
    const clean = key.trim().toUpperCase();
    localStorage.setItem(LICENSE_STORAGE_KEY, clean);
    // localStorage 'storage' events don't fire in the same tab, so dispatch a
    // custom event that hooks in this tab can subscribe to.
    window.dispatchEvent(new CustomEvent('bchradar:license-changed'));
  } catch {
    /* ignore */
  }
}

/** Remove the stored license key. */
export function clearStoredLicense(): void {
  try {
    localStorage.removeItem(LICENSE_STORAGE_KEY);
    window.dispatchEvent(new CustomEvent('bchradar:license-changed'));
  } catch {
    /* ignore */
  }
}
